// Whether API requests should use the operations Snowflake warehouse.
let useOperationsWarehouse = false;

export function setUseOperationsWarehouse(value) {
  useOperationsWarehouse = value;
}

export function getUseOperationsWarehouse() {
  return useOperationsWarehouse;
}
